import React, { Component } from 'react'
import Axios from 'axios'
import { toast, ToastContainer } from 'react-toastify'
import Loader from '../Loader'
import ProgressBar from "../ProgressBar/ProgressBar";
import { Urls } from '../../Urls'
import './UniqueLocation.css'
import { logActivity } from '../Utilities';
var raw_suggestion = []
var raw_input = []
var raw_manual = []
class UniqueLocation extends Component {
    constructor(props) {
        super(props)

        this.state = {
            fetched_data: [],
            loader: false
        }
    }
    componentDidMount() {
        // logActivity([
        //     {
        //         'screen': 'Unique Location Cleaning',
        //         'module': 'Location Cleaning',
        //         'user_activity': 'page viewed',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        document.title = "DC | Unique Location"
        var body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "unique"
        }
        this.setState({ loader: true }, () => {
            document.getElementById("header").style.opacity = "0.5"
            Axios.post(Urls.location.fetch, body)
                .then(response => {
                    document.getElementById("header").style.opacity = "1"
                    console.log(response.data)
                    this.setState({
                        fetched_data: response.data.data,
                        loader: false
                    }, () => { if (this.state.fetched_data.length === 0) { this.props.history.push({ pathname: "/multiLocation" }) } })
                    var i;
                    for (i = 0; i < this.state.fetched_data.length; i++) {
                        raw_suggestion.push({ "suggestion": "Accepted" })
                        raw_manual.push({ "suggestion": "Accepted" })
                    }
                })
                .catch(error => {
                    this.setState({ loader: false })
                    console.log(error)
                    toast.error("Error while fetching data from database!")
                })
        })
    }

    checkhHandler = (event) => {
        raw_suggestion[event.target.name] = { "suggestion": event.target.value }
        raw_manual[event.target.name] = { "suggestion": event.target.value }

    }

    submitHandler = (event) => {
        event.preventDefault()
        // logActivity([
        //     {
        //         'screen': 'Unique Location Cleaning',
        //         'module': 'Location Cleaning',
        //         'user_activity': 'data submission',
        //         'timestamp': new Date().toISOString()
        //     }
        // ])
        raw_input = []
        raw_input.push(raw_suggestion)
        raw_input.push(raw_manual)
        event.preventDefault()
        var body = {
            "dataset_id": localStorage.getItem("dataset_id"),
            "key": "unique",
            "input": raw_input
        }
        // Call Location Dumping API
        document.getElementById("header").style.opacity = "0.5"
        this.setState({
            loader: true
        }, () => {
            Axios.post(Urls.location.dump, body)
                .then(response => {
                    console.log(response)
                    this.setState({ loader: false })
                    sessionStorage.setItem('prevScreen', this.props.history.location.pathname)
                    document.getElementById("header").style.opacity = "1"
                    this.props.history.push({ pathname: '/multiLocation' })
                })
                .catch(error => {
                    this.setState({ loader: false })
                    console.log(error)
                    toast.error("Erro while processing your request!")
                })
        })
    }

    goToHeaderMapping = () => this.props.history.push({ pathname: "/header_mapping" })

    goToLocationCleaning = () => this.props.history.push({ pathname: "/uniqueLocation" })

    goToVendorCleaning = () => this.props.history.push({ pathname: "/directMatchVendor" })

    goToTruckCleaning = () => this.props.history.push({ pathname: "/directMatchTruck" })

    goToSummary = () => this.props.history.push({ pathname: "/summaryScreen" })

    render() {
        var items = this.state.fetched_data
        return (
            <div id="header">
                <ToastContainer />
                <Loader isLoading={this.state.loader} />
                <div className={'tooltip-absolute'}>
                    <div className={'top-tooltip-container'}>
                        <div className={'top-tooltip-element'}>
                            <i style={{fontSize: '20px'}} className={'fa fa-info-circle'}></i>
                        </div>
                        <div className={'top-tooltip-message'}>
                            Mismatched states are highlighted with yellow color!
                        </div>
                    </div>
                </div>
                <div className="container">
                    <div style={{ "margin-bottom": "5%" }}>
                        <div className="row" align="center">
                            <div className="col-1">
                                <button onClick={this.goToHeaderMapping}><i className="navButtonsCircleLeft fas fa-arrow-circle-left"></i></button>
                            </div>
                            <div className="col-10">
                                <table border="1" id="dc_table">
                                    <thead>
                                        <tr>
                                            <th>Sr. No.</th>
                                            <th>
                                                Raw Locations
                                        </th>
                                            <th>
                                                Raw State
                                    </th>
                                            <th>
                                                Cleaned Location
                                    </th>
                                            <th>
                                                Cleaned State
                                    </th>
                                            <th>
                                                Mark as Correct
                                    </th>
                                        </tr>
                                    </thead>
                                    {
                                        (items.length === 0) ? (
                                            <tbody></tbody>
                                        ) : (
                                                <tbody>
                                                    {
                                                        items.map((item, i) =>
                                                            (item['Raw State'] !== item['StateName']) ? (
                                                                <tr style={{ backgroundColor: "#f1fa3c" }}>
                                                                    <td>{i + 1}</td>
                                                                    <td>
                                                                        {
                                                                            item['Raw Location']
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item['Raw State']
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item['Raw Location_S']
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        {
                                                                            item['StateName']
                                                                        }
                                                                    </td>
                                                                    <td>
                                                                        <select name={i} onChange={this.checkhHandler}>
                                                                            <option value="Accepted">Accepted</option>
                                                                            <option value="Rejected">Rejected</option>
                                                                        </select>
                                                                    </td>
                                                                </tr>
                                                            ) : (
                                                                    <tr>
                                                                        <td>{i + 1}</td>
                                                                        <td>
                                                                            {
                                                                                item['Raw Location']
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item['Raw State']
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item['Raw Location_S']
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            {
                                                                                item['StateName']
                                                                            }
                                                                        </td>
                                                                        <td>
                                                                            <select name={i} onChange={this.checkhHandler}>
                                                                                <option value="Accepted">Accepted</option>
                                                                                <option value="Rejected">Rejected</option>
                                                                            </select>
                                                                        </td>
                                                                    </tr>
                                                                )
                                                        )
                                                    }
                                                </tbody>
                                            )
                                    }
                                </table>
                            </div>
                            <div className="col-1 navButtonsCircleRight">
                                <button onClick={this.submitHandler} title="Submit" ><i className=" fas fa-arrow-circle-right"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="footer_div">
                    <ProgressBar progress="42%" />
                </div>
            </div>
        )
    }
}

export default UniqueLocation
